"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1x4y9ql-0"
})(["align-items:center;width:100%;padding:", "px;background-color:", ";", "{padding:", "px;}"], (0, _themeGet.themeGet)('space.3'), function (props) {
  return (0, _pclnDesignSystem.getPaletteColor)(props.backgroundColor)(props);
}, (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('space.3'));
var LeftContent = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1x4y9ql-1"
})(["justify-content:flex-start;align-items:center;width:100%;"]);
var RightContent = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-1x4y9ql-2"
})(["justify-content:flex-end;align-items:flex-end;width:100%;"]);

var Logo = _styledComponents["default"].img.withConfig({
  componentId: "sc-1x4y9ql-3"
})(["display:flex;height:50px;margin-right:", "px;", "{margin-right:", "px;}"], (0, _themeGet.themeGet)('space.2'), (0, _themeGet.themeGet)('mediaQueries.lg'), (0, _themeGet.themeGet)('space.4'));

var Title = _styledComponents["default"].div.withConfig({
  componentId: "sc-1x4y9ql-4"
})(["display:flex;font-size:", "px;"], (0, _themeGet.themeGet)('fontSizes.4'));

function AppBar(_ref) {
  var className = _ref.className,
      backgroundColor = _ref.backgroundColor,
      logoUrl = _ref.logoUrl,
      title = _ref.title,
      actions = _ref.actions;
  return _react["default"].createElement(Container, {
    className: className,
    backgroundColor: backgroundColor
  }, _react["default"].createElement(LeftContent, null, logoUrl && _react["default"].createElement(Logo, {
    src: logoUrl
  }), title && _react["default"].createElement(Title, null, title)), actions && _react["default"].createElement(RightContent, null, actions));
}

AppBar.displayName = 'AppBar';
AppBar.propTypes = {
  className: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  logoUrl: _propTypes["default"].string,
  title: _propTypes["default"].node,
  actions: _propTypes["default"].node
};
AppBar.defaultProps = {
  className: '',
  backgroundColor: 'background.base'
};

var _default = (0, _react.memo)(AppBar);

exports["default"] = _default;